<template>
    <div>
        <!-- 拖拽小题 -->
        <span 
            v-for="(test,num) in item.questions"
            :key="num"
            :class="{on:index==currentNode[0]&&num==currentNode[1]}"
        >
            <!-- 接收容器 -->
            <i
                v-if="boxDragEnter"
                class="drop"
                @drop.stop="boxDrop($event,test,num)"
                @dragover.stop="allDrag($event)"
                @dragenter.stop="boxDragHover($event,test,num,1)"
                @dragleave.stop="boxDragHover($event,test,num,0)"
            ></i>
            <!-- 拖拽容器 -->
            <i
                class="drag"
                draggable="true" 
                @dragstart.stop="boxDragStart($event,test,num)"
                @dragend.stop="boxDragEnd($event)"
                @click.stop="boxDragClick(test,num)"
            >{{setNumber(index,num+1)}}</i>
        </span>
        <span v-if="index!=currentNode[0]&&boxDragEnter">
            <!-- 接收容器 -->
            <i
                class="drag"
                @drop.stop="boxDrop($event,null,item.questions.length)"
                @dragover.stop="allDrag($event)"
                @dragenter.stop="boxDragHover($event,null,null,1)"
                @dragleave.stop="boxDragHover($event,null,null,0)"
            ></i>
        </span>
    </div>
</template>

<script>
import $store from '../store'
export default {
    props: ['item','index'],//item小题列表，index题组序号
    data () {
        return {
        }
    },
    methods: {
        boxDrop(e,test,num){//释放
            e.target.style = ''
            $store.commit('MOVEASSEMBLYNODE',[this.index,num])//移动小题
            this.$nextTick(function () {
                this.$emit('toScroll')//移动完成，定位到小题位置
            })
        },
        allDrag(e){//组织默认事件
            e.preventDefault();
            e.stopPropagation();
        },
        boxDragStart(e,test,num){//拖拽开始
            e.dataTransfer.setData('aaa', '')
            let data = [this.index,num]
            $store.commit('SETSELECTEDNODE',data)//选中小题
            this.boxDragEnter = true
        },
        boxDragEnd(){//拖拽结束
            this.boxDragEnter = false
        },
        boxDragHover(e,item,index,type){//拖拽进入容器区域
            if(type == 1){
                e.target.style.border = '1px dashed #5A75F6'
            }else{
                e.target.style = ''
            }
        },
        boxDragClick(test,num){//点击选中小题
            let data = [this.index,num]
            $store.commit('SETSELECTEDNODE',data)
            this.$emit('toScroll')
        },
        setNumber(index,num){//计算序号
            let sum = 0
            this.assemblyData.segment_list.forEach((el,i)=>{
                if(i>=index){
                    return
                }
                sum += el.questions.length
            })
            sum=sum+num
            return sum
        },
    },
    computed: {
        assemblyData(){
            return $store.state.assemblyData
        },
        currentNode(){
            return $store.state.currentNode
        },
        boxDragEnter:{
            get(){
                return $store.state.boxDragEnter
            },
            set(val){
                $store.state.boxDragEnter = val
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// packages/question-assembly/src/leftBoxGroup.vue